"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "af", {
  enumerable: true,
  get: function get() {
    return _af.default;
  }
});
Object.defineProperty(exports, "arDZ", {
  enumerable: true,
  get: function get() {
    return _arDZ.default;
  }
});
Object.defineProperty(exports, "arSA", {
  enumerable: true,
  get: function get() {
    return _arSA.default;
  }
});
Object.defineProperty(exports, "be", {
  enumerable: true,
  get: function get() {
    return _be.default;
  }
});
Object.defineProperty(exports, "bg", {
  enumerable: true,
  get: function get() {
    return _bg.default;
  }
});
Object.defineProperty(exports, "bn", {
  enumerable: true,
  get: function get() {
    return _bn.default;
  }
});
Object.defineProperty(exports, "ca", {
  enumerable: true,
  get: function get() {
    return _ca.default;
  }
});
Object.defineProperty(exports, "cs", {
  enumerable: true,
  get: function get() {
    return _cs.default;
  }
});
Object.defineProperty(exports, "cy", {
  enumerable: true,
  get: function get() {
    return _cy.default;
  }
});
Object.defineProperty(exports, "da", {
  enumerable: true,
  get: function get() {
    return _da.default;
  }
});
Object.defineProperty(exports, "de", {
  enumerable: true,
  get: function get() {
    return _de.default;
  }
});
Object.defineProperty(exports, "el", {
  enumerable: true,
  get: function get() {
    return _el.default;
  }
});
Object.defineProperty(exports, "enAU", {
  enumerable: true,
  get: function get() {
    return _enAU.default;
  }
});
Object.defineProperty(exports, "enCA", {
  enumerable: true,
  get: function get() {
    return _enCA.default;
  }
});
Object.defineProperty(exports, "enGB", {
  enumerable: true,
  get: function get() {
    return _enGB.default;
  }
});
Object.defineProperty(exports, "enUS", {
  enumerable: true,
  get: function get() {
    return _enUS.default;
  }
});
Object.defineProperty(exports, "eo", {
  enumerable: true,
  get: function get() {
    return _eo.default;
  }
});
Object.defineProperty(exports, "es", {
  enumerable: true,
  get: function get() {
    return _es.default;
  }
});
Object.defineProperty(exports, "et", {
  enumerable: true,
  get: function get() {
    return _et.default;
  }
});
Object.defineProperty(exports, "faIR", {
  enumerable: true,
  get: function get() {
    return _faIR.default;
  }
});
Object.defineProperty(exports, "fi", {
  enumerable: true,
  get: function get() {
    return _fi.default;
  }
});
Object.defineProperty(exports, "fr", {
  enumerable: true,
  get: function get() {
    return _fr.default;
  }
});
Object.defineProperty(exports, "frCA", {
  enumerable: true,
  get: function get() {
    return _frCA.default;
  }
});
Object.defineProperty(exports, "gl", {
  enumerable: true,
  get: function get() {
    return _gl.default;
  }
});
Object.defineProperty(exports, "gu", {
  enumerable: true,
  get: function get() {
    return _gu.default;
  }
});
Object.defineProperty(exports, "he", {
  enumerable: true,
  get: function get() {
    return _he.default;
  }
});
Object.defineProperty(exports, "hi", {
  enumerable: true,
  get: function get() {
    return _hi.default;
  }
});
Object.defineProperty(exports, "hr", {
  enumerable: true,
  get: function get() {
    return _hr.default;
  }
});
Object.defineProperty(exports, "hu", {
  enumerable: true,
  get: function get() {
    return _hu.default;
  }
});
Object.defineProperty(exports, "hy", {
  enumerable: true,
  get: function get() {
    return _hy.default;
  }
});
Object.defineProperty(exports, "id", {
  enumerable: true,
  get: function get() {
    return _id.default;
  }
});
Object.defineProperty(exports, "is", {
  enumerable: true,
  get: function get() {
    return _is.default;
  }
});
Object.defineProperty(exports, "it", {
  enumerable: true,
  get: function get() {
    return _it.default;
  }
});
Object.defineProperty(exports, "ja", {
  enumerable: true,
  get: function get() {
    return _ja.default;
  }
});
Object.defineProperty(exports, "ka", {
  enumerable: true,
  get: function get() {
    return _ka.default;
  }
});
Object.defineProperty(exports, "kk", {
  enumerable: true,
  get: function get() {
    return _kk.default;
  }
});
Object.defineProperty(exports, "ko", {
  enumerable: true,
  get: function get() {
    return _ko.default;
  }
});
Object.defineProperty(exports, "lt", {
  enumerable: true,
  get: function get() {
    return _lt.default;
  }
});
Object.defineProperty(exports, "lv", {
  enumerable: true,
  get: function get() {
    return _lv.default;
  }
});
Object.defineProperty(exports, "ms", {
  enumerable: true,
  get: function get() {
    return _ms.default;
  }
});
Object.defineProperty(exports, "nb", {
  enumerable: true,
  get: function get() {
    return _nb.default;
  }
});
Object.defineProperty(exports, "nl", {
  enumerable: true,
  get: function get() {
    return _nl.default;
  }
});
Object.defineProperty(exports, "nn", {
  enumerable: true,
  get: function get() {
    return _nn.default;
  }
});
Object.defineProperty(exports, "pl", {
  enumerable: true,
  get: function get() {
    return _pl.default;
  }
});
Object.defineProperty(exports, "pt", {
  enumerable: true,
  get: function get() {
    return _pt.default;
  }
});
Object.defineProperty(exports, "ptBR", {
  enumerable: true,
  get: function get() {
    return _ptBR.default;
  }
});
Object.defineProperty(exports, "ro", {
  enumerable: true,
  get: function get() {
    return _ro.default;
  }
});
Object.defineProperty(exports, "ru", {
  enumerable: true,
  get: function get() {
    return _ru.default;
  }
});
Object.defineProperty(exports, "sk", {
  enumerable: true,
  get: function get() {
    return _sk.default;
  }
});
Object.defineProperty(exports, "sl", {
  enumerable: true,
  get: function get() {
    return _sl.default;
  }
});
Object.defineProperty(exports, "sr", {
  enumerable: true,
  get: function get() {
    return _sr.default;
  }
});
Object.defineProperty(exports, "srLatn", {
  enumerable: true,
  get: function get() {
    return _srLatn.default;
  }
});
Object.defineProperty(exports, "sv", {
  enumerable: true,
  get: function get() {
    return _sv.default;
  }
});
Object.defineProperty(exports, "ta", {
  enumerable: true,
  get: function get() {
    return _ta.default;
  }
});
Object.defineProperty(exports, "te", {
  enumerable: true,
  get: function get() {
    return _te.default;
  }
});
Object.defineProperty(exports, "th", {
  enumerable: true,
  get: function get() {
    return _th.default;
  }
});
Object.defineProperty(exports, "tr", {
  enumerable: true,
  get: function get() {
    return _tr.default;
  }
});
Object.defineProperty(exports, "ug", {
  enumerable: true,
  get: function get() {
    return _ug.default;
  }
});
Object.defineProperty(exports, "uk", {
  enumerable: true,
  get: function get() {
    return _uk.default;
  }
});
Object.defineProperty(exports, "vi", {
  enumerable: true,
  get: function get() {
    return _vi.default;
  }
});
Object.defineProperty(exports, "zhCN", {
  enumerable: true,
  get: function get() {
    return _zhCN.default;
  }
});
Object.defineProperty(exports, "zhTW", {
  enumerable: true,
  get: function get() {
    return _zhTW.default;
  }
});

var _af = _interopRequireDefault(require("date-fns/locale/af"));

var _arDZ = _interopRequireDefault(require("date-fns/locale/ar-DZ"));

var _arSA = _interopRequireDefault(require("date-fns/locale/ar-SA"));

var _be = _interopRequireDefault(require("date-fns/locale/be"));

var _bg = _interopRequireDefault(require("date-fns/locale/bg"));

var _bn = _interopRequireDefault(require("date-fns/locale/bn"));

var _ca = _interopRequireDefault(require("date-fns/locale/ca"));

var _cs = _interopRequireDefault(require("date-fns/locale/cs"));

var _cy = _interopRequireDefault(require("date-fns/locale/cy"));

var _da = _interopRequireDefault(require("date-fns/locale/da"));

var _de = _interopRequireDefault(require("date-fns/locale/de"));

var _el = _interopRequireDefault(require("date-fns/locale/el"));

var _enAU = _interopRequireDefault(require("date-fns/locale/en-AU"));

var _enCA = _interopRequireDefault(require("date-fns/locale/en-CA"));

var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));

var _enUS = _interopRequireDefault(require("date-fns/locale/en-US"));

var _eo = _interopRequireDefault(require("date-fns/locale/eo"));

var _es = _interopRequireDefault(require("date-fns/locale/es"));

var _et = _interopRequireDefault(require("date-fns/locale/et"));

var _faIR = _interopRequireDefault(require("date-fns/locale/fa-IR"));

var _fi = _interopRequireDefault(require("date-fns/locale/fi"));

var _fr = _interopRequireDefault(require("date-fns/locale/fr"));

var _frCA = _interopRequireDefault(require("date-fns/locale/fr-CA"));

var _gl = _interopRequireDefault(require("date-fns/locale/gl"));

var _gu = _interopRequireDefault(require("date-fns/locale/gu"));

var _he = _interopRequireDefault(require("date-fns/locale/he"));

var _hi = _interopRequireDefault(require("date-fns/locale/hi"));

var _hr = _interopRequireDefault(require("date-fns/locale/hr"));

var _hu = _interopRequireDefault(require("date-fns/locale/hu"));

var _hy = _interopRequireDefault(require("date-fns/locale/hy"));

var _id = _interopRequireDefault(require("date-fns/locale/id"));

var _is = _interopRequireDefault(require("date-fns/locale/is"));

var _it = _interopRequireDefault(require("date-fns/locale/it"));

var _ja = _interopRequireDefault(require("date-fns/locale/ja"));

var _ka = _interopRequireDefault(require("date-fns/locale/ka"));

var _kk = _interopRequireDefault(require("date-fns/locale/kk"));

var _ko = _interopRequireDefault(require("date-fns/locale/ko"));

var _lt = _interopRequireDefault(require("date-fns/locale/lt"));

var _lv = _interopRequireDefault(require("date-fns/locale/lv"));

var _ms = _interopRequireDefault(require("date-fns/locale/ms"));

var _nb = _interopRequireDefault(require("date-fns/locale/nb"));

var _nl = _interopRequireDefault(require("date-fns/locale/nl"));

var _nn = _interopRequireDefault(require("date-fns/locale/nn"));

var _pl = _interopRequireDefault(require("date-fns/locale/pl"));

var _pt = _interopRequireDefault(require("date-fns/locale/pt"));

var _ptBR = _interopRequireDefault(require("date-fns/locale/pt-BR"));

var _ro = _interopRequireDefault(require("date-fns/locale/ro"));

var _ru = _interopRequireDefault(require("date-fns/locale/ru"));

var _sk = _interopRequireDefault(require("date-fns/locale/sk"));

var _sl = _interopRequireDefault(require("date-fns/locale/sl"));

var _sr = _interopRequireDefault(require("date-fns/locale/sr"));

var _srLatn = _interopRequireDefault(require("date-fns/locale/sr-Latn"));

var _sv = _interopRequireDefault(require("date-fns/locale/sv"));

var _ta = _interopRequireDefault(require("date-fns/locale/ta"));

var _te = _interopRequireDefault(require("date-fns/locale/te"));

var _th = _interopRequireDefault(require("date-fns/locale/th"));

var _tr = _interopRequireDefault(require("date-fns/locale/tr"));

var _ug = _interopRequireDefault(require("date-fns/locale/ug"));

var _uk = _interopRequireDefault(require("date-fns/locale/uk"));

var _vi = _interopRequireDefault(require("date-fns/locale/vi"));

var _zhCN = _interopRequireDefault(require("date-fns/locale/zh-CN"));

var _zhTW = _interopRequireDefault(require("date-fns/locale/zh-TW"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }